document.addEventListener("DOMContentLoaded", function() {

  let lgContainer = document.querySelector(".gallery-container");
  const lg = lightGallery(lgContainer, {
    speed: 500,
    plugins: [lgZoom, lgVideo],
    selector: '.gallery-item',
    download : false,
    getCaptionFromTitleOrAlt : false,
    hideScrollbar: true,
    counter: false,
    allowMediaOverlap: true,
    videojs: true,
    mobileSettings:{ controls: false, showCloseIcon: true, download: false  } 
  });

  lgContainer.addEventListener('changeGalleryItems', () => {
    lg.refresh();
  });

});